<template>
  <index
    :status="estatusSolicitid"
    :details="true"
  />
</template>

<script>
import Index from './Index.vue'

export default {
  name: 'ObservcionesPrebecario',
  components: {
    Index,
  },
  data() {
    return {
      estatusSolicitid: 1,
    }
  },
}
</script>
